import type { ApiClient } from '@travel/api-client';

import type { GeneralContents } from 'GeneralContents-Types';
import { fetchEditableContents } from 'utils/editableContents';

export const fetchAll = (
  http: ApiClient,
  page: string,
  market: string,
  language: string,
): Promise<GeneralContents> =>
  fetchEditableContents(http, page, 'introductiontext', market, language).then(data => {
    if (!data) {
      return {};
    }

    if (data.value_prop?.length) {
      data.value_prop.sort(
        (itemA: { display_order: number }, itemB: { display_order: number }) =>
          itemA.display_order - itemB.display_order,
      );
    }

    return data;
  });
